
import { RouteObject } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import ErrorBoundary from '../components/ErrorBoundary';

// Lazy load components for better performance
const HomePage = lazy(() => import('../pages/home/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms/page'));
const SafetyStandardsPage = lazy(() => import('../pages/safety/page'));
const NotFoundPage = lazy(() => import('../pages/not-found/page'));

// Loading component for lazy loaded routes
const PageLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <div>Loading...</div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <HomePage />
        </Suspense>
      </ErrorBoundary>
    ),
    errorElement: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <NotFoundPage />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: '/privacy-policy',
    element: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <PrivacyPolicyPage />
        </Suspense>
      </ErrorBoundary>
    ),
    errorElement: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <NotFoundPage />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: '/terms-of-service',
    element: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <TermsOfServicePage />
        </Suspense>
      </ErrorBoundary>
    ),
    errorElement: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <NotFoundPage />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: '/safety-standards',
    element: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <SafetyStandardsPage />
        </Suspense>
      </ErrorBoundary>
    ),
    errorElement: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <NotFoundPage />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: '*',
    element: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <NotFoundPage />
        </Suspense>
      </ErrorBoundary>
    ),
  },
];

export default routes;
